import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleNajlepszy2026() {
  return <ArticleTemplate article={articles[2]} />;
}